import { ToggleSwitch } from '@/src/components/common/ui/toggleSwitch'
import { useClearFilters } from '@/src/hooks/srp/clearFilters'
import useStopFilterManager from '@/src/hooks/srp/stopFilterManager'
import { TranslationFunction } from '@/src/types/translations'
import { FilterList as SortIcon, Tune } from '@mui/icons-material'
import { Badge, Box, Chip, Typography } from '@mui/material'
import React from 'react'

interface SrpFilterAndSortTabBarProps {
    onFilterClick?: () => void
    onSortClick?: () => void
    t: TranslationFunction<'common'>
}

const SrpFilterAndSortTabBar: React.FC<SrpFilterAndSortTabBarProps> = ({ onFilterClick, onSortClick, t }) => {
    const { nonStopToggle, nonStopChecked, isNonstopFlightAvailable: showNonstopToggle } = useStopFilterManager()
    const { numberOfFiltersApplied } = useClearFilters()
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                bgcolor: 'transparent',
                py: 1,
                px: 1
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.3 }}>
                <Badge badgeContent={numberOfFiltersApplied || 0} color="primary">
                    <Chip
                        color={!!numberOfFiltersApplied ? 'primary' : undefined}
                        size="medium"
                        variant="outlined"
                        // sx={{ display: 'flex', alignItems: 'center', gap: 0.5, cursor: 'pointer' }}
                        onClick={onFilterClick}
                        icon={<Tune fontSize="small" />}
                        label={
                            <Typography sx={{ fontWeight: 400, fontSize: '14px', color: 'text.primary' }}>
                                {t('filter')}
                            </Typography>
                        }
                    />
                </Badge>

                <Chip
                    color={'primary'}
                    size="medium"
                    variant="outlined"
                    onClick={onSortClick}
                    icon={<SortIcon sx={{ fontSize: 20, color: '#232323' }} />}
                    label={
                        // <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>

                        <Typography sx={{ fontWeight: 400, fontSize: '14px', color: 'text.primary' }}>
                            {t('sort')}
                        </Typography>
                        // </Box>
                    }
                />

                {showNonstopToggle && (
                    <Chip
                        color={!!nonStopChecked ? 'primary' : undefined}
                        size="medium"
                        variant={'outlined'}
                        onClick={nonStopToggle}
                        icon={<ToggleSwitch checked={!!nonStopChecked} />}
                        label={
                            <Typography sx={{ fontWeight: 400, fontSize: '14px', color: 'text.primary' }}>
                                {t('direct')}
                            </Typography>
                        }
                    />
                )}
            </Box>
        </Box>
    )
}

export default SrpFilterAndSortTabBar
